
import React from 'react';

interface LessonContentProps {
  content: string[];
  quote?: string;
  quoteAuthor?: string;
}

const LessonContent: React.FC<LessonContentProps> = ({ 
  content, 
  quote, 
  quoteAuthor 
}) => {
  return (
    <>
      <div className="space-y-4">
        {content.map((paragraph, index) => (
          <p key={index} className="text-hormony-charcoal/80 leading-relaxed">
            {paragraph}
          </p>
        ))}
      </div>
      
      {quote && (
        <blockquote className="border-l-4 border-hormony-coral pl-4 py-2 italic text-hormony-charcoal/80">
          "{quote}"
          {quoteAuthor && (
            <footer className="text-hormony-charcoal/60 text-sm mt-1">
              — {quoteAuthor}
            </footer>
          )}
        </blockquote>
      )}
    </>
  );
};

export default LessonContent;
